import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { UntilDestroy } from '@ngneat/until-destroy';
import { ChangeDetectionStrategy, Component, Input, OnInit, inject } from '@angular/core';

import {
  addToFavorite,
  clearShopsList,
  getShopsList,
  removeFromFavorite,
} from 'src/app/data/store/actions/shop.action';
import {
  selectCurrentShopsList,
  selectIsAllShopDataFetched,
  selectShopDataListIsLoading,
} from 'src/app/data/store/selectors/shop.selectors';
import {
  selectCurrentUserFavsShop,
  selectUsersDataIsLoading,
} from 'src/app/data/store/selectors/users.selectors';
import { IFiltersOptionsParam } from 'src/app/data/store/models/filters.model';
import { befreeUrlValues, noDataText } from 'src/app/shared/constants';
import { DepartmentsType, ShopsListTypes } from 'src/app/shared/enums';
import { IFavoriteStateOfShop } from 'src/app/shared/interfaces';
import { IShop } from 'src/app/shared/services/user/user.type';
import { getCurrentUser } from 'src/app/data/store/actions/users.actions';
import { getAdditionalDepartmentsList } from 'src/app/data/store/actions/department.action';
import { setFiltersOptions } from 'src/app/data/store/actions/filters.actions';
import { AsyncPipe } from '@angular/common';
import { SearchBarWithFiltersComponent } from '../search-bar-with-filters/search-bar-with-filters.component';
import { PaginationContainerComponent } from '../pagination-container/pagination-container.component';
import { ShopCardComponent } from '../shop-card/shop-card.component';
@UntilDestroy()
@Component({
  selector: 'app-common-shops-list',
  templateUrl: './common-shops-list.component.html',
  styleUrls: ['./common-shops-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    SearchBarWithFiltersComponent,
    PaginationContainerComponent,
    ShopCardComponent,
    AsyncPipe,
  ],
})
export class CommonShopsListComponent implements OnInit {
  private _store = inject(Store);

  @Input() requestId?: number;

  @Input() isRefreshing?: boolean;

  @Input() typeOfShopsPage = ShopsListTypes.allShops;

  public readonly noDataText = noDataText;

  public readonly listNameShops = befreeUrlValues.shopList;

  public readonly shopsListTypes = ShopsListTypes;

  public shops$: Observable<IShop[] | undefined> | undefined;

  public isLoading$ = this._store.select(selectShopDataListIsLoading);

  public allShopDataFetched$ = this._store.select(selectIsAllShopDataFetched);

  public clearShopsAction = clearShopsList();

  public filtersOptionsParams: IFiltersOptionsParam = {
    REGIONS: { params: null },
    CITIES: { params: null },
  };

  private _favoriteShopList$ = this._store.select(selectCurrentUserFavsShop);

  ngOnInit(): void {
    this._store.dispatch(
      setFiltersOptions({
        filtersOption: this.filtersOptionsParams ?? null,
      }),
    );

    this.shops$ =
      this.typeOfShopsPage === ShopsListTypes.favShops
        ? this._favoriteShopList$
        : this._store.select(selectCurrentShopsList);

    if (this.typeOfShopsPage === ShopsListTypes.favShops) {
      this.isLoading$ = this._store.select(selectUsersDataIsLoading);
      this._store.dispatch(getCurrentUser());
    } else if (this.requestId) {
      this._store.dispatch(
        getAdditionalDepartmentsList({
          departmentId: this.requestId,
          departmentType: DepartmentsType.shop,
        }),
      );
    }

    this.getShops();
  }

  public getShops() {
    if (this.typeOfShopsPage === ShopsListTypes.allShops) {
      this._store.dispatch(getShopsList());
    } else if (this.typeOfShopsPage === ShopsListTypes.regionShops && this.requestId) {
      this._store.dispatch(
        getAdditionalDepartmentsList({
          departmentId: this.requestId,
          departmentType: DepartmentsType.shop,
        }),
      );
    }
  }

  public handlerFavoriteState(shopFavoriteState: IFavoriteStateOfShop) {
    if (!shopFavoriteState.isFavorite) {
      this._store.dispatch(addToFavorite({ shopId: shopFavoriteState.id }));
    } else {
      this._store.dispatch(removeFromFavorite({ shopId: shopFavoriteState.id }));
    }
  }

  public trackByFn(_index: number, shop: IShop) {
    return shop.id;
  }
}
